// api/careerApi.js
import axios from "axios";

const BASE_URL = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/career`,
});

const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

// 📨 Submit a BDE job application (public — used by CareerPage.jsx)
// multipart/form-data: firstName, lastName, phone, email, position, resume (file)
export async function submitApplication(formData) {
  try {
    const res = await BASE_URL.post(`/apply`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 📖 Get all applications (admin/HR) — optional ?status=pending|approved|rejected
export async function getAllApplications(status = "") {
  try {
    const res = await BASE_URL.get(`/applications`, {
      ...getHeaders(),
      params: status ? { status } : {},
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 👤 Get single application by ID (admin/HR)
export async function getApplicationById(id) {
  try {
    const res = await BASE_URL.get(`/applications/${id}`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ✅ Approve application — creates BDE staff account + invite link
// PATCH /applications/:id/approve   Body: { baseSalary, tempPassword? }
export async function approveApplication(id, baseSalary, tempPassword) {
  try {
    const res = await BASE_URL.patch(
      `/applications/${id}/approve`,
      { baseSalary, tempPassword },
      getHeaders()
    );
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ❌ Reject application
// PATCH /applications/:id/reject   Body: { reviewNotes? }
export async function rejectApplication(id, reviewNotes = "") {
  try {
    const res = await BASE_URL.patch(
      `/applications/${id}/reject`,
      { reviewNotes },
      getHeaders()
    );
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 📊 BDE Performance — admin/HR: every BDE's onboarding + incentive numbers
// GET /bde-performance
export async function getBdePerformance() {
  try {
    const res = await BASE_URL.get(`/bde-performance`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 📈 My Performance — BDE self: own onboarding + incentive numbers
// GET /my-performance
export async function getMyBdePerformance() {
  try {
    const res = await BASE_URL.get(`/my-performance`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}